import { useDispatch, useSelector } from 'react-redux'

import Permission from '../model/permissions.model'
import { FetchPermissionsProps } from '../services/permissions.service'
import { fetchPermissions } from '../store/permissions.reducer'
import {
  selectPermissions,
  selectPermissionsLoading,
  selectPermissionsError,
} from '../store/permissions.selectors'

import { StoreError } from '~/common/model'

interface usePermissions {
  getPermissions: (fetchPermissionsProps: FetchPermissionsProps) => unknown
  permissions?: Permission[]
  loading: boolean
  error?: StoreError
}

export default function usePermissions(): usePermissions {
  const dispatch = useDispatch()

  return {
    getPermissions: (fetchPermissionsProps: FetchPermissionsProps) =>
      dispatch(fetchPermissions(fetchPermissionsProps)),
    permissions: useSelector(selectPermissions),
    loading: useSelector(selectPermissionsLoading),
    error: useSelector(selectPermissionsError),
  }
}
